module.exports = __webpack_public_path__ + "b24fcf991f0bedd584bb7fd813ea8a51.jpg";